import { Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { AreaUnit } from '@core/data-access';

@Injectable()
export class AreaUnitPresetProvider implements FormlyFieldConfigPresetProvider {
  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'autocomplete',
      props: {
        placeholder: 'Please Select',
        autocomplete: [AreaUnit.Sqft, AreaUnit.Sqm],
      },
    };
  }
}

export function registerAreaUnitPreset(): ConfigOption {
  return { presets: [{ name: 'areaUnit', config: new AreaUnitPresetProvider() }] };
}
